import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getNewsList() {
    return httpAdminClient.get('admin/reports?page=1&per_page=10000');
  },
  createNew(data) {
    return httpAdminClient.post('admin/reports', { report: { ...data } });
  },
  patchNew(id, data) {
    return httpAdminClient.patch(`admin/reports/${id}`, { report: { ...data } });
  },
  deleteNew(id) {
    return httpAdminClient.delete(`admin/reports/${id}`);
  },
  showNew(id) {
    return httpAdminClient.get(`admin/reports/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/mediasApi.js